/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description UserRole
 */

/**
 * TODO(leah): Update this to bitmask land.
 * WARNING: if adding new "pro" role, may need to add to TENANT_AND_PRO_ROLES in ccpa/schema, ask Matt
 */
export enum UserRole {
  /** user created from feeds that has been converted to a login-based user */
  FEEDS_USER = 0,
  /** potential/actual tenant */
  TENANT = 1,
  /** Individual with 1+ units renting them out */
  LANDLORD = 2,
  /** Professional agent representing 1+ listings */
  AGENT = 3,
  /** Contact for a specific, large apartment building */
  BUILDING_REPRESENTATIVE = 4,
  /** Zumper staff, has edit rights on all listings + tool access */
  STAFF = 5,
  /** Zumper eng, has all site rights */
  SUPERUSER = 6,
  /** PadMapper post-a-pad user */
  PAD_POSTER = 7,
  /** Individual registered as PRO but has not selected a specific role. */
  PRO = 8,
  /** User who can access the Multifamily Portal */
  PORTAL_USER = 9,
}

Object.defineProperty(UserRole, '__ENUM_NAME', {
  value: 'UserRole',
  writable: false,
  configurable: false,
  enumerable: false,
})
